/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { forIn, groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';

import {
  dispatchOutstandingByLabererAndQtr,
  getOutstandingByLabererAndQtr,
} from '../Store/Action';
import {
  labererAndQuarterGrid,
  getAllLabererCol,
  getDefaultQtrOutstanding,
} from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

const DisOutstandingByLabererAndQuarter = () => {
  const dispatch = useDispatch();

  const [resultList, setResultList] = React.useState([]);
  const [searchResultList, setSearchResultList] = React.useState([]);
  const [resultHeader, setResultHeader] = React.useState([]);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const [count, setCount] = React.useState(1);
  const [filteredRows, setFilteredRow] = React.useState([]);

  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  const {
    // searchResult: getSearchResult,
    // rebateProgramName,
    // allRebateProgram,
    isLoading,
    // manufacturerSelected,
    displayObj: {
      // searchResult: getSearchResult,
      rebateProgramName,
      allRebateProgram,
      rebateProgrameName,
      manufacturerSelected,
    },
    searchResult: getSearchResult,
  } = useSelector(
    (state) => state?.sharedState?.OutstandingBalanceByLabererAndQuarterReducer
  );

  const allCols = getAllLabererCol();
  const [cellHead, setCellHead] = React.useState(allCols);

  // To update totals when no condition matches from filter
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  // Function to add the rows
  const [displayedRows, setDisplayedRows] = useState(searchResultList ?? []);

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : searchResultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : '0.00';
  };

  // columns to show total
  const createData = (count, prefix) => {
    const result = [];
    const tempObj = { isBottomRow: true, mfgId: 'Totals' };
    for (let i = 0; i < count; i++) {
      for (let j = 0; j < allCols.length; j++) {
        if (allCols[j].field != 'mfgId' && allCols[j].field != 'mfgName') {
          tempObj[allCols[j].field] = sum(allCols[j].field);
        }
      }
      result.push(tempObj);
    }
    return result;
  };

  // To pin the total row
  const pinnedBottomRowData = useMemo(() => {
    const pinned = createData(1, 'Bottom');
    if (!filterApply) {
      let qtrs = Object.keys(pinned[0]);
      qtrs = qtrs.filter((val) => parseFloat(pinned[0][val]) == 0);
      const actuals = allCols.filter((obj) => qtrs.indexOf(obj.field) === -1);
      setCellHead(actuals);
    }
    return pinned;
  }, [searchResultList, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // API call
  React.useEffect(() => {
    // dispatch(dispatchOutstandingByLabererAndQtr([]));
    // dispatch(
    //   getOutstandingByLabererAndQtr({
    //     mfgId:
    //       manufacturerSelected == 'ALL'
    //         ? manufacturerSelected
    //         : manufacturerSelected[0],
    //     rebateProgram: allRebateProgram
    //       ? 'ALL'
    //       : rebateProgrameName?.rebateProgramCd,
    //   })
    // );
  }, []);

  // SET data from API
  React.useEffect(() => {
    if (getSearchResult.length) {
      const data = groupBy(getSearchResult, 'mfgId');
      const rowData = [];
      for (const key in data) {
        const oneMfgData = data[key];
        let oneRowData = {
          mfgId: oneMfgData[0]?.mfgId,
          mfgName: oneMfgData[0]?.mfgName,
        };
        let sum = 0;
        for (let i = 0; i < oneMfgData.length; i++) {
          sum += oneMfgData[i].outstanding;
          oneRowData[oneMfgData[i].qtr] =
            oneMfgData[i].outstanding && oneMfgData[i].outstanding != 0
              ? oneMfgData[i].outstanding
              : '0.00';
        }

        oneRowData.totals = parseFloat(sum.toFixed(2));
        if (oneRowData.totals === 0) {
          oneRowData.totals = '0.00';
        }
        oneRowData = { ...getDefaultQtrOutstanding(), ...oneRowData };
        rowData.push(oneRowData);
      }
      setSearchResultList(rowData);
    }
  }, [getSearchResult]);

  // PDF header

  const thirdInfo = `Rebate Program:${
    allRebateProgram
      ? 'ALL'
      : `${rebateProgrameName?.rebateProgramCd} - ${rebateProgrameName?.shortDescr}`
  }`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <CustomSeparator
          parent1="State Reports"
          parent2="Display Outstanding Balance by Labeler and Quarter"
        />
      )}
      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          {!fullScreenView && (
            <>
              <div className="mui-custom-form input-md field-xl">
                <div className="row mb-4">
                  <div className="col-6">
                    <TextField
                      label="Rebate Program :"
                      id="Rebate Program :"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={
                        allRebateProgram
                          ? resultHeader[count - 1]?.rebateProgrameName || 'ALL'
                          : `${rebateProgrameName?.rebateProgramCd} - ${rebateProgrameName?.shortDescr}` ||
                            'ALL'
                      }
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {
        cellHead && cellHead?.length>2 &&
        <TableGridWithFeatures
        rowData={searchResultList?.map((item) => {
          return {
            ...item,
          };
        })}
        columnDefs={cellHead}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,
          autoHeaderHeight: true,
        }}
        hideTotalCount={false}
        exportFile
        reportName="Outstanding bal By labler & QTR Report"
        fileName="OutstandinGBalanceLabelerQtr"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ thirdInfo }}
        isScrollOn
        onFilterData={onFilterChanged}
        pinnedBottomRowData={pinnedBottomRowData}
        frameworkComponents={{
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;
            if (name && name.length > 20) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
        }}
        getFilterApply={getFilterApply}
      />
      }
    </div>
  );
};

export default DisOutstandingByLabererAndQuarter;
